/**
 * MN Split feature — start decoration shake when the section enters view,
 * then loop using the section duration setting.
 */
(function () {
  const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  const DESKTOP = window.matchMedia('(min-width: 990px)');

  function init(section) {
    if (!(section instanceof HTMLElement)) return;
    if (!section.querySelector('.mn-split-feature__decoration')) return;

    const play = () => {
      if (REDUCE.matches || !DESKTOP.matches) return;
      section.classList.add('mn-split-feature--deco-animate');
    };

    if (!('IntersectionObserver' in window)) {
      play();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          play();
          observer.disconnect();
          break;
        }
      },
      { threshold: 0.35, rootMargin: '0px' }
    );

    observer.observe(section);
  }

  function initAll() {
    document.querySelectorAll('.mn-split-feature').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target;
    if (!(root instanceof Element)) return;
    root.querySelectorAll('.mn-split-feature').forEach(init);
  });
})();
